import React, { useEffect, useRef, useState } from 'react';
import { useController } from 'react-hook-form';

import './checkbox.scss';

const CheckBox = (props) => {
  const { field } = useController(props);
  const { label } = props;
  const [checked, setCheck] = useState(field.value);

  useEffect(() => {
    field.onChange(checked);
  }, [checked]);

  return (
    <div className={'checkbox__icon'}>
      <div className={'input-wrap'}>
        <i
          className={`checkbox-icon ${checked ? 'icon-checked' : ''} ${props.errors ? 'error' : ''}`
          }
          onClick={() => {
            setCheck(!checked);
          }}
        ></i>
        <input
          {...field}
          id={props.id}
          className={props.errors ? 'input error' : 'input'}
          type={props.type}
          placeholder={props.placeholder}
          defaultChecked={props.checked}
        />
        <div className={`label-wrap ${props.labelNoClickable ? 'no-click' : ''}`}>
          {!props.labelNoClickable && (
            <label
              htmlFor={props.id}
              className={props.errors ? 'input__label error' : 'input__label'}
            >
                <span
                  onClick={() => {
                    setCheck(!checked);
                  }}
                >
                  {label}
                </span>
              {props.rules && props.rules.required ? <span className={'required'}>*</span> : ''}
            </label>
          )}

          {props.labelNoClickable && (
            <>
              <div
                className={
                  props.errors ? 'input__label-no-click error' : 'input__label-no-click'
                }
              >
                {label}
                {props.rules && props.rules.required ? (
                  <span className={'required'}>*</span>
                ) : (
                  ''
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckBox;
